module.exports = __webpack_public_path__ + "img/time.de6027f8.svg";